// Traduções da janela de pendências do Finalizado — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'shipments.finalizarPendencias.titulo': 'A Frente ainda não pode ser Finalizada',
    'shipments.finalizarPendencias.aviso': 'Resolva as pendências abaixo e tente de novo. Enquanto isso, a Frente pode ir para Finalizado com pendência.',
    'shipments.finalizarPendencias.maisItens': 'Mais {{n}} na Frente',
  },
  en: {
    'shipments.finalizarPendencias.titulo': 'The work front cannot be Finished yet',
    'shipments.finalizarPendencias.aviso': 'Resolve the items below and try again. Meanwhile, the work front can go to Finished with pending items.',
    'shipments.finalizarPendencias.maisItens': '{{n}} more on the work front',
  },
  es: {
    'shipments.finalizarPendencias.titulo': 'El frente todavía no puede Finalizarse',
    'shipments.finalizarPendencias.aviso': 'Resuelva los pendientes de abajo e intente de nuevo. Mientras tanto, el frente puede ir a Finalizado con pendiente.',
    'shipments.finalizarPendencias.maisItens': '{{n}} más en el frente',
  },
}
